import { useQueries } from "@tanstack/react-query";

import CampaignService from "services/Campaign";
import CaseService from "services/Case";
import ContactService from "services/Contact";
import EntityService from "services/Entity";

const PRESET_LOADERS = [
  ["entity", "entityId", id => EntityService.getEntity(id)],
  ["campaign", "campaignId", id => CampaignService.getCampaign(id)],
  ["contact", "contactId", id => ContactService.getContact(id)],
  ["caseRecord", "caseId", id => CaseService.get(id)],
];

/**
 * The records a create preset points at. The relation pickers need their
 * names, and the entity also carries the Region and Country to prefill.
 */
export const usePresetRecords = (preset = {}) =>
  useQueries({
    queries: PRESET_LOADERS.map(([name, key, load]) => ({
      queryKey: ["revenue-opportunity-preset", name, preset[key] ?? null],
      queryFn: () => load(preset[key]),
      enabled: preset[key] != null,
    })),
    // React Query keeps the combined result referentially stable while the
    // query results are unchanged, so `records` can feed memoized consumers.
    combine: results => ({
      records: Object.fromEntries(
        PRESET_LOADERS.map(([name], index) => [name, results[index].data])
      ),
      isPending: results.some(
        (result, index) =>
          preset[PRESET_LOADERS[index][1]] != null && result.isPending
      ),
      isError: results.some(result => result.isError),
    }),
  });
